import { Component } from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'react-apollo';
import compose from 'lodash.flowright';
import { connect } from 'react-redux';

import { getAlbumMembership } from '../../../util/account';
import { shouldShowUpsell } from '../utilities/web-galleries';
import { AccountWithAlbumMemberships } from '../graphql/queries/account';

class WebGalleryUpsellVisibility extends Component {
  static propTypes = {
    loading: PropTypes.bool,
    album: PropTypes.shape({
      id: PropTypes.string.isRequired,
      join_code: PropTypes.string,
      root_album_folder: PropTypes.shape({
        join_code: PropTypes.string,
      }),
    }).isRequired,
    account: PropTypes.shape({
      album_memberships: PropTypes.shape({
        records: PropTypes.arrayOf(
          PropTypes.shape({
            album: PropTypes.shape({
              id: PropTypes.string.isRequired,
            }).isRequired,
          }),
        ).isRequired,
      }).isRequired,
    }),
    children: PropTypes.func.isRequired,
  };

  userJoinedToAlbum = () => {
    const { album, account } = this.props;

    return !!getAlbumMembership(account, album.id);
  };

  render() {
    const { loading, album, children } = this.props;

    if (loading || !album) {
      return children(false);
    }

    // Don't show if the user is joined to the current album.
    return children(
      !this.userJoinedToAlbum() &&
        shouldShowUpsell(album, album.root_album_folder),
    );
  }
}

export { WebGalleryUpsellVisibility };

const mapStateToProps = ({ auth }) => ({
  authenticated: auth.authenticated,
});

const withAccountAlbumMemberships = graphql(AccountWithAlbumMemberships, {
  props: ({ data: { loading, me } }) => ({
    loading,
    account: me,
  }),
  skip: ({ authenticated }) => !authenticated,
});

export default compose(
  connect(mapStateToProps),
  withAccountAlbumMemberships,
)(WebGalleryUpsellVisibility);
